import { render, staticRenderFns } from "./his-task-manager.vue?vue&type=template&id=15ede8de&scoped=true"
import script from "./his-task-manager.vue?vue&type=script&lang=js"
export * from "./his-task-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ede8de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ede8de')) {
      api.createRecord('15ede8de', component.options)
    } else {
      api.reload('15ede8de', component.options)
    }
    module.hot.accept("./his-task-manager.vue?vue&type=template&id=15ede8de&scoped=true", function () {
      api.rerender('15ede8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/office/task/his-task-manager.vue"
export default component.exports